var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3;
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { html, LitElement } from "lit";
import UAParser from "ua-parser-js";
import { helper } from "../../common/helper";
import * as THEOplayer from 'theoplayer';
import { detect } from "../../common/detect";
import { getMediaSupport } from "./utils";
import WidevineContentProtectionIntegrationFactory from './WidevineContentProtectionIntegrationFactory.js';
import FairplayContentProtectionIntegrationFactory from './FairplayContentProtectionIntegrationFactory.js';
import dayjs from "dayjs";
window.THEOplayer = THEOplayer;
var sliceToLength = function sliceToLength(s) {
  return s.slice(0, 100);
};
var RTLPlayer = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLPlayer, _LitElement);
  function RTLPlayer() {
    var _this;
    _classCallCheck(this, RTLPlayer);
    _this = _callSuper(this, RTLPlayer);
    _this.type = "";
    _this.channelname = "";
    _this.container = "preroll";
    _this.vodtype = "";
    _this.emission = "";
    _this.vmap = "";
    _this.vmaporder = "pre,post,50p";
    _this.autoplay = false;
    _this.language = 'lb';
    _this.title = "";
    _this.location = "/components";
    _this.contentid = null;
    _this.duration = null;
    _this.play = false;
    _this.mediaSupport = "";
    _this.token = null;
    _this.nomobile = false;
    _this.usedrm = false;
    _this.lastTime = 0;
    _this.livestreamTimeOffset = 0;
    _this.lastProgress = 0;
    _this.hasUserInteracted = false;
    _this.player = null;
    _this.ua = new UAParser();
    return _this;
  }
  _createClass(RTLPlayer, [{
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.player.destroy();
    }
  }, {
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.usedrm) {
                _context.next = 4;
                break;
              }
              _context.next = 3;
              return getMediaSupport();
            case 3:
              this.mediaSupport = _context.sent;
            case 4:
              _get(_getPrototypeOf(RTLPlayer.prototype), "connectedCallback", this).call(this);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }
      return connectedCallback;
    }()
  }, {
    key: "createRenderRoot",
    value: function createRenderRoot() {
      return this;
    }
  }, {
    key: "_checkVersion",
    value: function _checkVersion() {
      var config = window.rtlsites.config;
      if (config.isAndroidApp) {
        if (config.appCode) {
          switch (config.currentApp) {
            case 'rtllu':
              return parseInt(config.appCode) >= 93;
            case 'rtl5min':
              return parseInt(config.appCode) >= 52;
            case 'rtltoday':
              return parseInt(config.appCode) >= 47;
            case 'eldolu':
              return parseInt(config.appCode) >= 52;
            default:
              return false;
          }
        }
      } else if (config.isIosApp) {
        return parseInt(config.appCode) >= 62003; // 62003
      } else {
        return true;
      }
    }
  }, {
    key: "_loadSportBuff",
    value: function () {
      var _loadSportBuff2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(playerElm) {
        var _window;
        var sportBuffContainer, appendContainer, destroyContainer;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              appendContainer = function appendContainer(containerToAppend) {
                sportBuffContainer = containerToAppend;
                playerElm.appendChild(containerToAppend);
              };
              destroyContainer = function destroyContainer() {
                if (!sportBuffContainer) return;
                playerElm.removeChild(sportBuffContainer);
              };
              _context2.next = 4;
              return (_window = window) === null || _window === void 0 ? void 0 : _window.SportBuff.init({
                //token: 'TOKEN',
                clientName: 'rtllux',
                player: 'custom-functions',
                streamSourceId: this.sportbuffid,
                anonymousLogin: true,
                appendContainer: appendContainer,
                destroyContainer: destroyContainer
              });
            case 4:
              window.widget = _context2.sent;
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function _loadSportBuff(_x) {
        return _loadSportBuff2.apply(this, arguments);
      }
      return _loadSportBuff;
    }()
  }, {
    key: "_getLevels",
    value: function _getLevels() {
      var output = "";
      var c = "";
      if (window.rtlsites.config.device === "t") this.container += "-tablet";
      if (window.rtlsites.config.device === "s") this.container += "-mobile";
      var pathFiltered = window.location.pathname.substr(1).split("/").filter(function (item) {
        return item != "" && item.indexOf(".html") == -1 && item.indexOf(".php") == -1;
      });
      if (pathFiltered.length > 0) {
        if (pathFiltered[0]) c = pathFiltered[0];
        for (var i = 1; i <= pathFiltered.length; i++) {
          output += `&fwd_level${i}=${pathFiltered[i - 1]}`;
        }
      }
      return output;
    }
  }, {
    key: "sendGoogleEvent",
    value: function sendGoogleEvent(event, type, data) {
      if (this.sendNoAnalytics) {
        console.log("Geoblocked, no analytics send");
        return;
      }
      if (type.startsWith("rtl_player") && this.program) {
        var _activeShow;
        var currentTime = Number(dayjs().format("HHMM"));
        var activeShow = null;
        this.program.forEach(function (entry) {
          var time = Number(entry.time.split(":").join(""));
          if (currentTime > time) activeShow = entry;
        });
        if ((_activeShow = activeShow) !== null && _activeShow !== void 0 && _activeShow.analytics) {
          // TODO: what about?
          // rtl_show_title
          // rtl_show_language
          // rtl_show_is_sponsored
          // rtl_show_is_podcast

          data["rtl_mm_show_id"] = activeShow.analytics["rtl_mm_show_id"];
          data["rtl_mm_show"] = activeShow.analytics["rtl_mm_show"];
        }
      }
      gtag(event, type, data);
    }
  }, {
    key: "handleProgressEvent",
    value: function handleProgressEvent(event, player, eventData) {
      if (player.ads.playing) return;
      var secondsBreakpoint = 30;
      if (this.type !== 'live') return;
      if (this.livestreamTimeOffset === 0) {
        this.livestreamTimeOffset = player.currentTime;
      }
      var timeOffset = this.livestreamTimeOffset;
      var progress = player.currentTime - timeOffset;

      // console.log("handleProgressEvent", progress, this.lastProgress, eventData)

      if (progress >= this.lastProgress + secondsBreakpoint) {
        this.lastProgress = progress;
        this.sendGoogleEvent("event", "rtl_player_playing", eventData);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      if (!this.hls && !this.dash && !this.shoutcast && !this.hlsaudio) return;
      if (!window.rtlsites.config.isApp) this.innerHTML = "";
      this.style.display = "block";
      this.prerollWeb = "";
      this.classList.add("videoplayer-container");
      var playerElm = document.createElement("div");
      playerElm.classList.add("videoplayer");
      playerElm.classList.add("theoplayer-container");
      playerElm.classList.add("video-js");
      playerElm.classList.add("theoplayer-skin");
      playerElm.classList.add("theo-seekbar-above-controls");
      playerElm.classList.add("media-video__player");
      var pageTags = window.rtlsites.config.page.tags;
      var posterImage = this.poster;

      // Device
      var dtype = "website";
      if (window.rtlsites.config.isApp) {
        if (window.rtlsites.config.device === "t") {
          dtype = "tablet-app";
        } else {
          dtype = "mobile-app";
        }
      } else {
        var uaDevice = this.ua.getDevice();
        if (uaDevice.type !== undefined) {
          dtype = uaDevice.type;
          switch (uaDevice.type) {
            case 'mobile':
              dtype = uaDevice.type + '-website';
              break;
            case 'website':
              dtype = uaDevice.type + '-website';
              break;
            default:
              dtype = 'website';
              break;
          }
        }
      }

      // VAST
      if (!this.preroll) {
        this.preroll = "";
        var smartclipId = `${window.rtlsites.config.currentApp}-${dtype}-instream`;

        // Content Length for IPL
        var conlen;
        if (this.duration >= 1 && this.duration <= 270) {
          conlen = Math.ceil(this.duration / 30);
          conlen = conlen * 30;
        } else if (this.duration > 270) {
          conlen = 300;
        }
        this.preroll += `type=vast4:vmapuri&ifa_type=dpid&s=${smartclipId}&vmap=${this.vmaporder}&ang_devset=313&`;
        this.preroll += `ang_ref=${encodeURIComponent(window.location.href)}`;
        if (conlen) this.preroll += `&fwd_conlength=${conlen}`;
        if (this.duration) this.preroll += `&ang_conlen=${this.duration}`;
        this.preroll += `&rnd=${Math.floor(Math.random() * 100000)}`;
        this.preroll += this._getLevels();
        if (window.rtlsites.config.ipDigId) this.preroll += `&ang_ifa=${window.rtlsites.config.ipDigId.id}`;
        if (this.emission) this.preroll += `&fwd_show=${this.emission}`;
        if (this.language) this.preroll += `&fwd_lang=${this.language}`;
        if (this.contentid) this.preroll += `&fwd_contentid=${this.contentid}`;
        if (window.rtlsites.config.article) this.preroll += `&fwd_articleid=${window.rtlsites.config.article.id}`;
        if (window.rtlsites.config.page) this.preroll += `&fwd_tags=${window.rtlsites.config.page.tags}`;

        // TODO: Sitekey
        //if (window.rtlsites.config.auID) this.preroll += `auId=${window.rtlsites.config.auID[dtype]}`;

        var userSegsPerm = JSON.parse(localStorage._psegs || "[]");
        userSegsPerm = userSegsPerm.slice(0, 750).toString();
        if (userSegsPerm) this.preroll += `&fwd_permutive=${userSegsPerm}`;
        if (window.didomiState && window.didomiState.didomiIABConsent) this.preroll += `&consent=${window.didomiState.didomiIABConsent}`;
        this.prerollWeb = `https://ad.sxp.smartclip.net/select?${this.preroll}`;

        //console.log("Preroll WEB", this.prerollWeb);
        //console.log("Preroll Mobile", this.preroll);
      }

      // Prepare Analytics
      var isLive = false;
      if (this.type === 'live') isLive = true;
      var statsAdd2URL = '';
      statsAdd2URL += 'rtl_mm_is_live=' + isLive;
      if (this.title) {
        statsAdd2URL += '&rtl_mm_title=' + encodeURIComponent(this.title.trim());
      }
      if (!isLive) statsAdd2URL += '&rtl_mm_is_episode=true';
      statsAdd2URL += '&rtl_mm_language=' + (this.language === 'lu' ? 'lb' : this.language);
      statsAdd2URL += '&rtl_mm_type=video';
      statsAdd2URL += '&page_location=' + encodeURIComponent(sliceToLength(window.location.origin + window.location.pathname));
      if (this.contentid) statsAdd2URL += '&rtl_content_id=' + this.contentid;
      if (this.episodeid) statsAdd2URL += '&rtl_mm_episode_id=' + this.episodeid;
      if (this.duration) statsAdd2URL += '&rtl_mm_duration=' + this.duration;
      if (this.show) statsAdd2URL += '&rtl_mm_show=' + encodeURIComponent(this.show.trim());
      if (this.showid) statsAdd2URL += '&rtl_mm_show_id=' + encodeURIComponent(this.showid.trim());
      if (this.channelname) statsAdd2URL += '&rtl_mm_channel=' + encodeURIComponent(this.channelname);
      if (this.season) statsAdd2URL += '&rtl_mm_season=' + encodeURIComponent(this.season);
      if (this.streamtype) statsAdd2URL += '&rtl_mm_stream_type=' + encodeURIComponent(this.streamtype);
      if (this.sourcetype) statsAdd2URL += '&rtl_mm_source_type=' + encodeURIComponent(this.sourcetype);
      if (this.scheduleid) statsAdd2URL += '&rtl_mm_stream_schedule_id=' + encodeURIComponent(this.scheduleid);
      if (this.streamdisplaytimein) statsAdd2URL += '&rtl_mm_show_start_ts=' + encodeURIComponent(this.streamdisplaytimein);
      if (this.streamdisplaytimeout) statsAdd2URL += '&rtl_mm_show_end_ts=' + encodeURIComponent(this.streamdisplaytimeout);
      if (this.channelencoder) statsAdd2URL += '&rtl_mm_channel_encoder=' + encodeURIComponent(this.channelencoder);
      if (this.program) statsAdd2URL += '&tv_program=true';

      // Player
      if (window.rtlsites.config.isApp && !window.rtlsites.config.isSportApp && !this.nomobile) {
        if (!posterImage) posterImage = window.rtlsites.config.assetsUrl + "/images/video_default.jpg";
        if (this.hls) {
          var paramprefix = this.hls.includes("?") ? "&" : "?";
          var mediaUrl = '';
          var adParams = window.btoa(this.preroll);
          var ybParams = window.btoa(statsAdd2URL);
          var params = '';
          if (this._checkVersion()) {
            if (window.rtlsites.config.ads === false) {
              params = `analytics=${ybParams}`;
            } else {
              params = `vast=${adParams}&analytics=${ybParams}`;
            }

            //if (this.sportbuffid) params += `&buff_stream_id=2756ea26-cb5b-426d-9464-c0174fca018b&buff_external_id=${this.sportbuffid}`;
            if (this.sportbuffid) params += `&buff_external_id=${this.sportbuffid}`;
            if (this.usedrm) params += `&drm=${this.contentid}`; // ContendID
          } else {
            if (window.rtlsites.config.ads === false) {
              params = `${statsAdd2URL}`;
            } else {
              params = `${this.preroll}&${statsAdd2URL}`;
            }
          }
          var streamUrl = this.hls;
          if (detect.isAndroidApp() && this.usedrm) streamUrl = this.dash;
          mediaUrl = `${window.rtlsites.config.currentApp}://media/${streamUrl}${paramprefix}${params}`;
          console.log("APP URL:", mediaUrl);
          return html(_t || (_t = _`<div class="media-video-app">
                        <a
                            href="${0}"
                            class="media-video-app__action"
                            ><div class="media-video-app__play">
                                <img
                                    class="media-video-app__poster"
                                    src="${0}"
                                /><img
                                    class="media-video-app__overlay"
                                    src="${0}/images/video_default_overlay_play.png"
                                /></div
                        ></a>
                    </div>`), mediaUrl, posterImage, window.rtlsites.config.assetsUrl);
        } else if (this.hlsaudio) {
          var _paramprefix;
          _paramprefix = this.hlsaudio.includes("?") ? "&" : "?";
          return html(_t2 || (_t2 = _`<div class="media-video-app">
                    <a
                        href="${0}://audiostream/${0}${0}${0}"
                        class="media-video-app__action"
                        ><div class="media-video-app__play">
                            <img
                                class="media-video-app__poster"
                                src="${0}"
                            /><img
                                class="media-video-app__overlay"
                                src="${0}/images/video_default_overlay_play.png"
                            /></div
                    ></a>
                </div>`), window.rtlsites.config.currentApp, this.hlsaudio, _paramprefix, statsAdd2URL, posterImage, window.rtlsites.config.assetsUrl);
        } else if (this.shoutcast) {
          var _paramprefix2;
          _paramprefix2 = this.shoutcast.includes("?") ? "&" : "?";
          return html(_t3 || (_t3 = _`<div class="media-video-app">
                    <a
                        href="${0}://audiostream/${0}${0}${0}"
                        class="media-video-app__action"
                        ><div class="media-video-app__play">
                            <img
                                class="media-video-app__poster"
                                src="${0}"
                            /><img
                                class="media-video-app__overlay"
                                src="${0}/images/video_default_overlay_play.png"
                            /></div
                    ></a>
                </div>`), window.rtlsites.config.currentApp, this.shoutcast, _paramprefix2, statsAdd2URL, posterImage, window.rtlsites.config.assetsUrl);
        }
      } else {
        // Add Player
        this.prepend(playerElm);
        var player = new THEOplayer.Player(playerElm, {
          libraryLocation: this.location + "/vendor/theoplayer6.10.0",
          license: "sZP7IYe6T6fZTSg6Tu3l0Zzk3QX6FSxg0ub-CDIlCmkg0ubi0uez0DI1TuC6FOPlUY3zWokgbgjNIOf9fKx63lbtIDIeFSbiTSa-3Q0ZTOk1IQ36FSbL3SakCLec3K4e3OfVfK4_bQgZCYxNWoryIQXzImf90SbL3lhi0Lfi0u5i0Oi6Io4pIYP1UQgqWgjeCYxgflEc3lCc3u0zTS0L3uerFOPeWok1dDrLYtA1Ioh6TgV6IDceWZrVUmfVfKIgIDxNUOrVUmfVfKgiWOrVUmfVfKcqCoXVdQjLUOfVfKrgUokgIQg1FKckf6i6bGxVFKckf6i6UQ1gWtAVCYggb6rlWoz6Ymi6IQj-CDgpbkjLWt4ZCoh6TgV6v6fVfKcqCoXVdQjLUOfVfGxEIDjiWQXrIYfpCoj-fgzVfG3edt06TgV6dwx-Wuh6Ymi6bo4pIXjNWYAZIY3LdDjpflNzbG4gya",
          // allowNativeFullscreen: true,

          ui: {
            width: "100%",
            fluid: true,
            poster: this.poster,
            playbackRates: [0.25, 0.75, 1, 1.25, 2]
          }
        });
        this.player = player;
        player.autoplay = this.autoplay;

        // Ads
        var ads = [];
        if (this.prerollWeb.length > 0 && window.rtlsites.config.ads == true) {
          if (this.adintegration === 'google-ima') {
            ads.push({
              sources: this.prerollWeb,
              integration: 'google-ima'
            });
          } else {
            ads.push({
              sources: this.prerollWeb
            });
          }
        }
        var mediaSupport = this.mediaSupport;

        // Sources
        var sources = [];
        if (this.hls && (this.usedrm ? mediaSupport === "hls" : true)) {
          sources.push({
            type: "application/x-mpegurl",
            src: this.hls,
            hls: {
              useLegacy: true
            }
          });
        }
        if (this.hlsaudio) {
          sources.push({
            type: "application/x-mpegurl",
            src: this.hlsaudio,
            hls: {
              useLegacy: true
            }
          });
        }
        if (this.dash && (this.usedrm ? mediaSupport === "dash" : true)) {
          sources.push({
            type: "application/dash+xml",
            src: this.dash
          });
        }
        if (this.shoutcast) {
          sources.push({
            type: "audio/mpeg",
            src: this.shoutcast
          });
        }
        var drmConfiguration = undefined;
        if (this.usedrm) {
          drmConfiguration = {
            widevine: {
              licenseAcquisitionURL: 'https://multidrm.vsaas.verimatrixcloud.net/widevine'
            },
            integration: "streamkeeper",
            fairplay: {
              licenseAcquisitionURL: 'https://multidrm.vsaas.verimatrixcloud.net/fairplay',
              certificateURL: 'https://stream.rtl.lu/drm/argus/fps_certificate.der'
            },
            integrationParameters: {
              contentId: this.contentid,
              player: playerElm
            }
          };
          THEOplayer.registerContentProtectionIntegration('streamkeeper', 'fairplay', new FairplayContentProtectionIntegrationFactory());
          THEOplayer.registerContentProtectionIntegration('streamkeeper', 'widevine', new WidevineContentProtectionIntegrationFactory());
        }

        //console.log("RTL Player", ads);

        player.abr.strategy = "quality";
        //player.preload = 'auto';
        player.source = {
          sources: sources,
          ads: ads,
          contentProtection: drmConfiguration
        };
        var eventData = {};
        console.log("GATITLE", this.title);
        eventData["rtl_mm_is_live"] = isLive.toString();
        if (this.title) eventData["rtl_mm_title"] = this.title.trim();
        if (!isLive) eventData["rtl_mm_is_episode"] = "true";
        eventData["rtl_mm_language"] = this.language === 'lu' ? 'lb' : this.language;
        eventData["rtl_mm_type"] = "video";
        if (this.contentid) eventData["rtl_content_id"] = this.contentid;
        if (this.episodeid) eventData["rtl_mm_episode_id"] = this.episodeid;
        if (this.duration) eventData["rtl_mm_duration"] = `${this.duration}`;
        if (this.show) eventData["rtl_mm_show"] = this.show.trim();
        if (this.showid) eventData["rtl_mm_show_id"] = this.showid.trim();
        if (this.channelname) eventData["rtl_mm_channel"] = this.channelname;
        if (this.season) eventData["rtl_mm_season"] = this.season;
        if (this.streamtype) eventData["rtl_mm_stream_type"] = this.streamtype;
        if (this.sourcetype) eventData["rtl_mm_source_type"] = this.sourcetype;
        if (this.scheduleid) eventData["rtl_mm_stream_schedule_id"] = this.scheduleid;
        if (this.channelencoder) eventData["rtl_mm_channel_encoder"] = this.channelencoder;
        var GABySite = {
          "rtl": "G-VCBQ3RV8YE",
          "5minutes": "G-01805R24NB",
          "today": "G-8NSCFCGHZ8",
          "eurovision": "G-SYVSVNQSXT"
        };
        var sendTo = GABySite["rtl"];
        if (window.rtlsites && window.rtlsites.config && window.rtlsites.config.product) sendTo = GABySite[window.rtlsites.config.product];

        //console.log("v sending to ", sendTo)

        eventData["send_to"] = sendTo;
        window.addEventListener("beforeunload", function (e) {
          if (!_this2.hasUserInteracted) return;
          var timeWatchedAll = 0;
          for (var i = 0; i < player.played.length; i++) {
            var timeWatched = (player.played.end(i) - player.played.start(i)).toFixed(2);
            timeWatchedAll = Number(timeWatchedAll) + Number(timeWatched);
          }
          eventData["rtl_mm_watch_time"] = Math.round(timeWatchedAll);
          if (timeWatchedAll) {
            var percentageWatched = Math.round(100 * eventData["rtl_mm_watch_time"] / _this2.duration);
            [90, 75, 50, 25, 10, 0].forEach(function (percentage) {
              if (percentageWatched >= percentage) percentageWatched = percentage;
            });
            eventData["rtl_mm_watch_progress"] = `${percentageWatched}`;
          }
          _this2.sendGoogleEvent("event", "rtl_player_end", eventData);
        });
        player.addEventListener(["loadedmetadata"], function (event) {
          _this2.hasUserInteracted = true;
          _this2.sendGoogleEvent("event", "rtl_player_start", eventData);
        });
        player.addEventListener("timeupdate", function (e) {
          return _this2.handleProgressEvent(e, player, eventData);
        });
        player.addEventListener(["destroy", "ended", "error", "pause", "play", "playing", "source_change", "waiting", "quality_change"], function (event) {
          //console.log(event);
          if (typeof gtag !== "undefined") {
            _this2.sendGoogleEvent("event", "rtl_player_" + event.type, eventData);
            _this2.sendGoogleEvent("event", event.type, {
              event_category: "video",
              event_label: player.src,
              value: Math.round(player.currentTime),
              send_to: "UA-1316751-51"
            });
          }
          if (event.type === 'play' || event.type === 'pause' || event.type === 'ended') {
            var date = new Date();
            try {
              beta('player', {
                'data': JSON.stringify({
                  //'device': 'desktop|smartphone|tablet',
                  'url': window.location.href,
                  'src': player.src,
                  'date': date.toUTCString(),
                  'event': event.type,
                  'currentTime': Math.round(player.currentTime)
                })
              });
            } catch (e) {}
          }
          if (event.type == "playing" || event.type == "pause" || event.type == "ended") {
            window.rtlsites.mediastate = event.type;
          }
        });
        player.ads.addEventListener(["adbegin", "adend", "aderror", "adimpression", "adskip"], function (event) {
          if (typeof gtag !== "undefined") {
            _this2.sendGoogleEvent("event", "rtl_ads_" + event.type.replace("ad", ""), eventData);
          }
        });

        // Poster should stay visible
        if (this.shoutcast || this.hlsaudio) {
          player.addEventListener("play", function (e) {
            var vjsPoster = playerElm.querySelector(".vjs-has-started .vjs-poster ");
            if (vjsPoster) {
              vjsPoster.style.display = "block";
            }
          });
        }

        // SPortBUFF
        if (this.sportbuffid) {
          //this._loadSportBuff(playerElm);
        }

        // https://github.com/Polymer/lit-element/pull/712 Check if still needed to to this
        return _get(_getPrototypeOf(RTLPlayer.prototype), "render", this).call(this);
      }
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        hls: {
          type: String
        },
        dash: {
          type: String
        },
        poster: {
          type: String
        },
        preroll: {
          type: String
        },
        vmap: {
          type: String
        },
        type: {
          type: String
        },
        channelname: {
          type: String
        },
        channelencoder: {
          type: String
        },
        container: {
          type: String
        },
        vodtype: {
          type: String
        },
        emission: {
          type: String
        },
        shoutcast: {
          type: String
        },
        hlsaudio: {
          type: String
        },
        autoplay: {
          type: Boolean
        },
        language: {
          type: String
        },
        title: {
          type: String
        },
        contentid: {
          type: String
        },
        episodeid: {
          type: String
        },
        isplay: {
          type: Boolean
        },
        adintegration: {
          type: String
        },
        show: {
          type: String
        },
        season: {
          type: String
        },
        duration: {
          type: Number
        },
        nomobile: {
          type: Boolean
        },
        vmaporder: {
          type: String
        },
        usedrm: {
          type: Boolean
        },
        sportbuffid: {
          type: String
        },
        streamtype: {
          type: String
        },
        sourcetype: {
          type: String
        },
        scheduleid: {
          type: String
        },
        streamdisplaytimein: {
          type: String
        },
        streamdisplaytimeout: {
          type: String
        },
        sendNoAnalytics: {
          type: Boolean
        },
        program: {
          type: Array
        }
      };
    }
  }]);
  return RTLPlayer;
}(LitElement);
export { RTLPlayer as default };
window.customElements.define("rtl-player", RTLPlayer);